import React from 'react'

export default function HomeAboutUsSection() {
  return (
    <section className="about-area-3 bg-white pb-lg-120 pb-60">
    <div className="container">
      <div className="section-title">
        <span className="short-title-2">ABout us</span>
        <h1 className="wow fadeInUp">Learn about how BankShoppy works</h1>
      </div>
      <div className="row align-items-center pt-60 gy-lg-0 gy-4">
        <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.1s">
          <div>
            <h5>
              <span className="round-dot" /> <span>7,000+</span> Happy Customers
            </h5>
            <p>
             {/* // content about the customers service  */}
              We have a large customer base that is always active and satisfied with our services.

            </p>
          </div>
          <div className="mt-40">
            <h5>
              <span className="round-dot" /> <span>100+</span> Business Partners
            </h5>
            <p>
              {/* // content about the business partners */}
              We have a large number of business partners who are always ready to help our customers.
            </p>
          </div>
        </div>
        <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.3s">
          <div className="video-tut">
            <img src="img/home-5/about-us-img.png" alt="" />
            <a
              className="play-btn"
              data-fancybox=""
              href="https://www.youtube.com/watch?v=xcJtL7QggTI"
              tabIndex={0}
            >
              <i className="fas fa-play" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}
